export default "__VITE_ASSET__nambSI97__"